import SignUpForm from './sign-up-form';
import LogInForm from './log-in-form';
import ResetPasswordForm from './reset-password-form';
import EditProfileForm from './edit-profile-form';


export default {
  SignUpForm,
  LogInForm,
  ResetPasswordForm,
  EditProfileForm
};




// WEBPACK FOOTER //
// ./src/forms/index.js